import React from 'react';
import { StateLanguage } from '../../languages/config/StateLanguage';

interface Props {
  status: 'connecting' | 'open' | 'closed';
  onClose: () => void;
  viewMode?: 'conversation' | 'history';
  onToggleHistory?: () => void;
  onNewConversation?: () => void;
}

const CopilotHeader: React.FC<Props> = ({status, onClose, viewMode, onToggleHistory, onNewConversation}) => {
  const {lang} = StateLanguage()

  return (
    <div className="card-header pe-5">
      <div className="card-title">
        <div className="d-flex justify-content-center flex-column me-3">
          <span className="fs-4 fw-bolder text-gray-900 me-1 mb-2 lh-1">
            {lang.labels.copilotTitle}
          </span>
          <div className="mb-0 lh-1">
            {status === 'open' && (
              <>
                <span className="badge badge-success badge-circle w-10px h-10px me-1"></span>
                <span className="fs-7 fw-bold text-muted">{lang.labels.copilotOnline}</span>
              </>
            )}
            {status === 'connecting' && (
              <>
                <span className="badge badge-warning badge-circle w-10px h-10px me-1"></span>
                <span className="fs-7 fw-bold text-muted">{lang.labels.copilotConnecting}</span>
              </>
            )}
            {status === 'closed' && (
              <>
                <span className="badge badge-danger badge-circle w-10px h-10px me-1"></span>
                <span className="fs-7 fw-bold text-muted">{lang.labels.copilotDisconnected}</span>
              </>
            )}
          </div>
        </div>
      </div>
      <div className="card-toolbar d-flex gap-1">
        {/* New conversation button (visible in conversation view when a thread is active) */}
        {viewMode === 'conversation' && onNewConversation && (
          <button
            className="btn btn-sm btn-icon btn-active-light-primary"
            type="button"
            title={lang.labels.copilotNewConversation}
            onClick={onNewConversation}
          >
            <span className="svg-icon svg-icon-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="5" fill="currentColor" />
                <rect x="10.8891" y="17.8033" width="12" height="2" rx="1" transform="rotate(-90 10.8891 17.8033)" fill="currentColor" />
                <rect x="6.01041" y="10.9247" width="12" height="2" rx="1" fill="currentColor" />
              </svg>
            </span>
          </button>
        )}
        {/* History toggle button */}
        {onToggleHistory && (
          <button
            className={`btn btn-sm btn-icon ${viewMode === 'history' ? 'btn-light-primary' : 'btn-active-light-primary'}`}
            type="button"
            title={lang.labels.copilotHistory}
            onClick={onToggleHistory}
          >
            <span className="svg-icon svg-icon-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M13 11.8V3.00318C13 2.45089 12.5523 2 12 2C11.4477 2 11 2.44932 11 3.00159V12C11 12.2652 11.1054 12.5196 11.2929 12.7071L16.2929 17.7071C16.6834 18.0976 17.3166 18.0976 17.7071 17.7071C18.0976 17.3166 18.0976 16.6834 17.7071 16.2929L13 11.8Z" fill="currentColor"/>
                <path opacity="0.3" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="currentColor"/>
              </svg>
            </span>
          </button>
        )}
        {/* Close button */}
        <button className="btn btn-sm btn-icon btn-active-light-primary" type="button" onClick={onClose}>
          <span className="svg-icon svg-icon-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="black" />
              <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="black" />
            </svg>
          </span>
        </button>
      </div>
    </div>
  )
}

export default CopilotHeader;
